import PrevBtn from "shared/assets/images/PrevBtn.svg";
import NextBtn from "shared/assets/images/NextBtn.svg";
import { Button } from "shared/ui/button";
import { useMobile } from "shared/lib/hooks";
import styles from "./News.module.scss";

export const News = ({ newsImg, posterUrl, newsName, newsDate }) => {
  const isMobile = useMobile("950px");
  return (
    <div className={styles.newsContainer}>
      <div className={styles.newsWrapper}>
        <video
          className={styles.newsWrapper__img}
          src={newsImg}
          poster={posterUrl}
          controls
          playsInline
          preload="metadata"
        />
        <div className={styles.newsWrapper__textBlock}>
          <div className={styles.newsWrapper__text}>
            <p className={styles.newsWrapper__name}>{newsName}</p>
            <p className={styles.newsWrapper__date}>{newsDate}</p>
          </div>
          {/* <div className={styles.newsWrapper__buttonsBlock}>
            <div className={styles.newsWrapper__buttons}>
              <Button
                variant="ghost"
                size="small"
                leftIcon={
                  <img src={PrevBtn} alt="perev" height={isMobile ? 34 : 48} />
                }
                disabled={true}
              />
              <Button
                variant="ghost"
                size="small"
                leftIcon={
                  <img src={NextBtn} alt="next" height={isMobile ? 34 : 48} />
                }
                disabled={true}
              />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};
